import axios from 'axios';
import Constants from '../constants';
import { EmailTemplateType, IEmailTemplate } from '../models';

export const getEmailTemplatesQuery = (
	surveyId: number,
	audienceId: number,
	emailTemplateId?: number,
	emailTemplateType?: EmailTemplateType,
) => {
	let url = Constants.API_EMAILTEMPLATES_URL.replace('{surveyId}', surveyId.toString()).replace('{audienceId}', audienceId.toString());

	if (emailTemplateId) {
		url += `/${emailTemplateId}`;
	}

	if (emailTemplateType) {
		url += '?emailInvitationType=' + Number(emailTemplateType);
	}

	return url;
};

export async function getEmailTemplates(
	surveyId: number,
	audienceId: number,
	emailTemplateType?: EmailTemplateType,
): Promise<IEmailTemplate[]> {
	const res = await axios.get(getEmailTemplatesQuery(surveyId, audienceId, undefined, emailTemplateType), {
		headers: { Pragma: 'no-cache' },
	});
	return res.data;
}

export async function addEmailTemplate(surveyId: number, emailTemplate: IEmailTemplate): Promise<IEmailTemplate> {
	const res = await axios.post(getEmailTemplatesQuery(surveyId, emailTemplate.audienceId), emailTemplate);
	return res.data;
}

export async function updateEmailTemplate(surveyId: number, emailTemplate: IEmailTemplate): Promise<IEmailTemplate> {
	const res = await axios.put(getEmailTemplatesQuery(surveyId, emailTemplate.audienceId, emailTemplate.emailTemplateId), emailTemplate);
	return res.data;
}

export async function deleteEmailTemplate(surveyId: number, audienceId: number, emailTemplateId: number): Promise<IEmailTemplate> {
	const res = await axios.delete(getEmailTemplatesQuery(surveyId, audienceId, emailTemplateId));
	return res.data;
}

export async function archiveAudienceEmailTemplates(surveyId: number, audienceId: number): Promise<any> {
	const res = await axios.delete(getEmailTemplatesQuery(surveyId, audienceId) + '/archive');
	return res.data;
}

export async function getEmailTemplateListFromQuestionLibrary() {
	const res = await axios.get(Constants.API_QUESTION_LIBRARY_EMAIL_TEMPLATES_LIST_URL);
	return res.data;
}
